export enum SidebarActiontypes {
    SET_SHOW_SIDEBAR = "@@sidebar/SET_SHOW_SIDEBAR",
  }
  